import CryptoJS from 'crypto-js';

const DecryptData = (encryptedData: string, secretKey: string) => {
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedData) {
        console.log('Decryption failed or invalid UTF-8 encoding');
    }

    return decryptedData;
};

export default DecryptData;